import { useEffect } from "react";
import WebApp from "@twa-dev/sdk";

/**
 * Хук для управления Telegram BackButton
 * @param {string} view - текущий вид (home, add, edit, list, help, ai-scan)
 * @param {Function} resetForm - функция сброса формы
 * @param {Function} setView - функция установки вида
 */
export function useBackButton(view, resetForm, setView) {
  useEffect(() => {
    // Показываем BackButton только на страницах, отличных от home
    if (view !== "home") {
      WebApp.BackButton.show();
      
      const handleBackClick = () => {
        // Сбрасываем форму при выходе из add/edit/ai-scan
        if (view === "add" || view === "edit" || view === "ai-scan") {
          resetForm();
        }
        setView("home");
      };
      
      WebApp.BackButton.onClick(handleBackClick);
      
      // Cleanup: удаляем обработчик при размонтировании
      return () => {
        WebApp.BackButton.offClick(handleBackClick);
      };
    } else {
      WebApp.BackButton.hide();
    }
  }, [view, resetForm, setView]);
}
